import { getCaptchaToken } from '@/lib/turnstile';

import { toApiError } from '../ApiError';
import { CAPTCHA_ACTIONS, postPublicSubmission } from '../publicSubmission';

import { type EnquiryInput, type EnquiryReceipt } from './types';

function toPayload(input: EnquiryInput): Record<string, unknown> {
  const details = Object.fromEntries(
    Object.entries(input.details ?? {}).filter(([, v]) => v !== '' && v !== undefined),
  );
  return {
    kind: input.kind,
    full_name: input.fullName,
    phone: input.phone,
    email: input.email ?? null,
    message: input.message ?? null,
    details,
    vehicle_slug: input.vehicleSlug ?? null,
    vehicle_stock_no: input.vehicleStockNo ?? null,
    page_path: input.pagePath ?? null,
    company_website: input.companyWebsite ?? null,
  };
}

/**
 * The only write the public site performs for enquiries. The captcha is checked
 * by `submit-website-enquiry` before the database is reached; the RPC validates
 * everything again (§39).
 */
export async function submitEnquiry(input: EnquiryInput): Promise<EnquiryReceipt> {
  try {
    const captchaToken = await getCaptchaToken(CAPTCHA_ACTIONS.enquiry);
    const { reference_no } = await postPublicSubmission<{ reference_no: string }>(
      'submit-website-enquiry',
      {
        payload: toPayload(input),
        captcha_token: captchaToken,
      },
    );
    return { referenceNo: reference_no };
  } catch (error) {
    throw toApiError(error);
  }
}
